"use client";

import React, { useState } from "react";
import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogClose } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Search, ArrowRight, X, Maximize2 } from "lucide-react";
import { cn } from "@/lib/utils";
const projects = [{
  id: 1,
  title: "Hudson Master Suite Remodel",
  category: "Bathrooms",
  image: "https://amazing-satyr.10web.cloud/wp-content/uploads/2026/03/IMG_4358-scaled.jpg?v=bs7fgbw2rqo",
  description: "A complete transformation of a dated master bath into a timeless sanctuary. We utilized classic subway tiling contrasted with oil-rubbed bronze fixtures and custom-milled oak vanities. The design honors traditional craftsmanship while providing modern luxury.",
  details: ["Custom-milled oak cabinetry", "Hand-laid porcelain tile", "Oil-rubbed bronze hardware", "Heated limestone flooring"],
  gallery: ["https://wpvc-images.s3.us-east-1.amazonaws.com/images/1576980/img/kitchen_detail_sink_01.png", "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1576980/img/kitchen_detail_island_01.png", "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1576980/img/bathroom_suite_shower_01.png", "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1576980/img/bathroom_suite_tiles_01.png", "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1576980/img/bathroom_hudson_vanity_01.png", "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1576980/img/bathroom_hudson_shower_detail_01.png", "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1576980/img/bathroom_hudson_tub_area_01.png", "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1576980/img/bathroom_hudson_lighting_01.png", "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1576980/img/bathroom_hudson_tiling_01.png", "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1576980/img/bathroom_hudson_fixture_01.png", "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1576980/img/bathroom_hudson_storage_01.png", "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1576980/img/bathroom_hudson_entry_01.png"]
}, {
  id: 2,
  title: "Hudson Kitchen Remodel",
  category: "Kitchens",
  image: "https://amazing-satyr.10web.cloud/wp-content/uploads/2026/03/project_ellsworth_kitchen.webp?v=zqux0zrnkic",
  description: "Designed for a retired professional who loves to host, this kitchen features heritage-grade cabinetry and professional appliances. The focus was on creating a functional workspace that feels like a warm, integrated part of the home's architecture.",
  details: ["Quarter-sawn oak cabinets", "Professional-grade range", "Hidden appliance garage", "Classic crown molding details"],
  gallery: ["https://wpvc-images.s3.us-east-1.amazonaws.com/images/1576980/img/bathroom_detail_shower_01.png", "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1576980/img/bathroom_detail_vanity_01.png"]
}, {
  id: 3,
  title: "St. Croix Valley Lower Level",
  category: "Basements",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1576980/img/flooring_hardwood_oak_01.png",
  description: "We transformed an unfinished basement into a sophisticated entertainment suite. Featuring a custom wet bar, climate-controlled storage, and a cozy fireplace, it serves as the ultimate family gathering space for Wisconsin winters.",
  details: ["Custom wet bar with granite", "Integrated entertainment system", "Moisture-proof insulation", "High-durability LVP flooring"],
  gallery: ["https://wpvc-images.s3.us-east-1.amazonaws.com/images/1576980/img/flooring_detail_corner_01.png", "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1576980/img/flooring_detail_transition_01.png"]
}, {
  id: 4,
  title: "Hudson Kitchen Update",
  category: "Kitchens",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1576980/img/kitchen_midnight_modern_02.png",
  description: "A restoration-focused kitchen remodel that brings back the home's original character. We paired deep navy base cabinets with warm white uppers and copper accents to create a space that feels both established and fresh.",
  details: ["Two-tone heritage palette", "Farmhouse apron-front sink", "Walk-in walk-through pantry", "Solid brass hardware"],
  gallery: ["https://wpvc-images.s3.us-east-1.amazonaws.com/images/1576980/img/kitchen_detail_stove_02.png", "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1576980/img/kitchen_detail_pantry_02.png"]
}, {
  id: 5,
  title: "Hudson Master Bathroom",
  category: "Bathrooms",
  image: "https://amazing-satyr.10web.cloud/wp-content/uploads/2026/03/IMG_1523-scaled.jpg?v=h9otthz0zu4",
  description: "Bringing 20 years of experience to this luxury bathroom, we created a spa-like retreat with a zero-entry shower and accessibility features that don't compromise on high-end aesthetics.",
  details: ["Zero-entry steam shower", "Radiant floor heating", "Double quartz vanity", "Custom tiled niches"],
  gallery: ["https://wpvc-images.s3.us-east-1.amazonaws.com/images/1576980/img/bathroom_detail_sink_02.png", "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1576980/img/bathroom_detail_tile_02.png", "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1576980/img/bathroom_spa_tub_01.png", "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1576980/img/bathroom_spa_details_01.png", "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1576980/img/bathroom_prescott_steam_shower_01.png", "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1576980/img/bathroom_prescott_bench_detail_01.png", "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1576980/img/bathroom_prescott_radiant_floor_01.png", "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1576980/img/bathroom_prescott_dual_vanity_01.png", "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1576980/img/bathroom_prescott_niche_detail_01.png", "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1576980/img/bathroom_prescott_window_view_01.png", "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1576980/img/bathroom_prescott_hardware_detail_01.png", "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1576980/img/bathroom_prescott_mood_lighting_01.png"]
}, {
  id: 6,
  title: "River Falls Basement Finish",
  category: "Basements",
  image: "https://amazing-satyr.10web.cloud/wp-content/uploads/2026/03/project_prescott_basement.webp?v=ng9qzplmkt",
  description: "For this basement remodel, we focused on light and height. By maximizing ceiling clearance and adding strategic recessed lighting, we created a bright, airy family room that feels nothing like a traditional basement.",
  details: ["Recessed LED lighting plan", "Sound-dampening ceiling", "Custom built-in shelving", "Additional guest suite"],
  gallery: ["https://wpvc-images.s3.us-east-1.amazonaws.com/images/1576980/img/flooring_detail_texture_02.png", "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1576980/img/flooring_detail_light_02.png"]
}];
export default function TheResults() {
  const [filter, setFilter] = useState("All");
  const [selectedProject, setSelectedProject] = useState<(typeof projects)[0] | null>(null);
  const filteredProjects = filter === "All" ? projects : projects.filter(p => p.category === filter);
  return <section data-section-id="31950" id="craftsmanship-showcase" className="bg-background text-foreground py-24 px-4 md:px-8 relative overflow-hidden">
      {}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-primary/10 to-transparent" />
      <div className="absolute -top-40 -right-40 w-96 h-96 bg-secondary/30 rounded-full blur-3xl pointer-events-none" />

      <div className="max-w-7xl mx-auto">
        {}
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-8 mb-16">
          <div className="max-w-2xl">
            <h2 className="text-accent font-sans font-semibold tracking-widest uppercase text-xs mb-3">
              Our Portfolio
            </h2>
            <h3 className="text-4xl md:text-5xl font-serif text-primary leading-tight">
              Transforming Visions into <span className="italic text-accent">Reality</span>
            </h3>
            <p className="mt-4 text-muted-foreground text-lg max-w-xl font-sans">
              With over 20 years of experience in Hudson and the St. Croix Valley, our work speaks for itself. Explore our gallery of premium bathroom, kitchen, and basement remodels.
            </p>
          </div>

          {}
          <div className="w-full md:w-auto overflow-x-auto pb-2 md:pb-0">
            <ToggleGroup type="single" value={filter} onValueChange={value => {
            if (value) setFilter(value);
          }} className="bg-secondary/40 p-1 rounded-sm border border-border inline-flex min-w-full md:min-w-0">
              {["All", "Bathrooms", "Kitchens", "Basements"].map((item, i) => <ToggleGroupItem key={item} value={item} data-index={i} className="px-6 py-2 rounded-sm text-sm font-sans font-medium transition-all data-[state=on]:bg-primary data-[state=on]:text-primary-foreground hover:bg-secondary/60 hover:text-primary">
                  {item}
                </ToggleGroupItem>)}
            </ToggleGroup>
          </div>
        </div>

        {}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {filteredProjects.map((project, i) => <div key={project.id} data-index={i} className="group relative cursor-pointer" onClick={() => setSelectedProject(project)}>
              <div className="relative overflow-hidden rounded-sm border border-primary/10 bg-card shadow-sm transition-all duration-500 hover:shadow-xl hover:border-primary/30">
                <AspectRatio ratio={4 / 5}>
                  <img src={project.image} alt={project.title} className="h-full w-full object-cover transition-transform duration-1000 group-hover:scale-105" />
                  {}
                  <div className="absolute inset-0 bg-gradient-to-t from-primary/90 via-primary/10 to-transparent opacity-40 transition-opacity duration-300 group-hover:opacity-70" />
                  
                  {}
                  <div className="absolute inset-0 flex flex-col justify-end p-6 translate-y-4 transition-transform duration-300 group-hover:translate-y-0">
                    <span className="text-accent text-xs font-bold tracking-widest uppercase mb-2 opacity-0 transition-opacity duration-300 delay-100 group-hover:opacity-100">
                      {project.category}
                    </span>
                    <h4 className="text-xl font-serif text-white mb-1">
                      {project.title}
                    </h4>
                    <div className="h-0 overflow-hidden transition-all duration-300 group-hover:h-8">
                      <div className="flex items-center text-secondary text-sm pt-2 font-sans">
                        <span>View Project Details</span>
                        <ArrowRight className="ml-2 h-4 w-4" />
                      </div>
                    </div>
                  </div>

                  {}
                  <div className="absolute top-4 right-4 p-2 bg-primary/20 backdrop-blur-md rounded-full text-white opacity-0 transform translate-y-[-10px] transition-all duration-300 group-hover:opacity-100 group-hover:translate-y-0 border border-white/20">
                    <Maximize2 className="h-4 w-4" />
                  </div>
                </AspectRatio>
              </div>
            </div>)}
        </div>

        {}
        <Dialog open={!!selectedProject} onOpenChange={open => !open && setSelectedProject(null)}>
          <DialogContent className="max-w-4xl bg-background border-border p-0 overflow-hidden gap-0 rounded-sm">
            {selectedProject && <div className="flex flex-col md:flex-row h-full max-h-[90vh] md:max-h-[80vh] overflow-y-auto md:overflow-hidden">
                {}
                <div className="w-full md:w-1/2 relative h-64 md:h-auto">
                  <img src={selectedProject.image} alt={selectedProject.title} className="absolute inset-0 w-full h-full object-cover" />
                  <div className="absolute inset-0 bg-gradient-to-t from-primary/40 to-transparent md:hidden" />
                </div>

                {}
                <div className="w-full md:w-1/2 p-6 md:p-10 flex flex-col bg-card">
                  <DialogHeader className="mb-6 text-left">
                    <div className="flex items-center justify-between">
                      <span className="text-accent text-xs font-bold tracking-widest uppercase">
                        {selectedProject.category}
                      </span>
                    </div>
                    <DialogTitle className="text-3xl font-serif text-primary mt-2">Basement Finish</DialogTitle>
                    <DialogDescription className="text-muted-foreground mt-4 text-base font-sans leading-relaxed">
                      {selectedProject.description}
                    </DialogDescription>
                  </DialogHeader>

                  <div className="space-y-6 flex-1">
                    <div>
                      <h5 className="text-xs font-bold text-primary uppercase tracking-widest mb-3 border-b border-border pb-2">
                        Project Highlights
                      </h5>
                      <ul className="grid grid-cols-1 gap-2">
                        {selectedProject.details.map((detail, i) => <li key={i} data-index={i} className="flex items-start text-sm text-muted-foreground font-sans">
                            <span className="mr-2 text-accent">•</span>
                            {detail}
                          </li>)}
                      </ul>
                    </div>

                    {}
                    <div>
                      <h5 className="text-xs font-bold text-primary uppercase tracking-widest mb-3 border-b border-border pb-2">
                        Craftsmanship Gallery
                      </h5>
                      <div className="grid grid-cols-2 gap-3">
                        {selectedProject.gallery.map((img, i) => <div key={i} data-index={i} className="relative aspect-square rounded-sm overflow-hidden border border-primary/5">
                            <img src={img} alt={`Detail ${i + 1}`} className="w-full h-full object-cover hover:scale-105 transition-transform duration-700" />
                          </div>)}
                      </div>
                    </div>
                  </div>

                  <div className="mt-8 pt-6 border-t border-border flex justify-end">
                    <Button variant="outline" onClick={() => setSelectedProject(null)} className="border-primary/20 rounded-sm font-sans hover:bg-primary hover:text-primary-foreground transition-colors">
                      Close Gallery
                    </Button>
                  </div>
                </div>
              </div>}
          </DialogContent>
        </Dialog>
      </div>
    </section>;
}